import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import Modal from "react-bootstrap/Modal";
import { ModalBody } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { DeleteDustbin, AddwithWhiteCircle, } from "../AllSvg";
import { handleErrorToast, customSortByKey } from "../CustomFunctions";
import { formatDate, formattedDateLong } from "../Date";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { CustomCSSForSearchableSelect } from "../CustomUtilities";

const AddCompoffShortLeaveForm = ({ getCompensatoryList, SUPER_ADMIN, PERMISSION_HR_ADMIN, SUB_COMPANIES, EmpCode, PORTAL_SETTINGS }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => {
        setShow(true);
        getAllEmp_code(formData.sub_company);

        if (!PERMISSION_HR_ADMIN && EmpCode) {
            setFormData((prev) => ({
                ...prev,
                empcode: EmpCode
            }));
            getSelectedEmpData(EmpCode);
            getShortleaveDate(EmpCode);
        }
    };
    const handleClose = () => {
        setFormData(initialData);
        setEligibleDates([]);
        setErrors({});
        setShow(false);
    };

    const initialData = {
        // empcode: sessionStorage.getItem('emp_code'),
        empcode: "",
        date: "",
        reason: "",
        duration: "",
        instructed_by: "",
        created_by: sessionStorage.getItem('emp_code'),
        sub_company: sessionStorage.getItem('company_id'),
        short_leave_balance: 0,
    }


    const [formData, setFormData] = useState(initialData);
    const [buffer, setBuffering] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const isShortLeaveDisabled = PORTAL_SETTINGS?.eligible_for_shortleave_credit === false;
    const canApplyShortLeave = !isShortLeaveDisabled;

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "sub_company", "empcode", "instructed_by", "reason", "date"

        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                const formattedFieldName = field
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                newErrors[field] = `${formattedFieldName
                    } is required !`;
            }
        });

        // Also check if we have eligible dates and can determine duration
        if (formData.date && eligibleDates.length > 0) {
            const selectedDateInfo = eligibleDates.find(d => d.date === formData.date);
            if (!selectedDateInfo) {
                newErrors.date = "Selected date is not valid!";
            }
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const [eligibleDates, setEligibleDates] = useState([]);
    const [empList, setEmpList] = useState([]);
    const [empData, setEmpData] = useState({});
    const [buffer1, setBuffering1] = useState(false);
    const [buffer2, setBuffering2] = useState(false);

    const getAllEmp_code = async (companyId) => {
        setBuffering1(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${companyId || formData.sub_company}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(sortedList);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const getSelectedEmpData = async (empcode) => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${empcode}/`);
            setEmpData(res.data);
            
            const leave = await axios.get(`${BASE_URL}/wfm/leavebalance/${empcode}/`);
            setFormData(prev => ({ ...prev, short_leave_balance: leave.data.short_leave || 0 }));
        } catch (err) {
        } finally {
            setBuffering2(false);
        }
    };
    const eligibleDateConditions = {
        // "start_date": "2025-12-01",
        "start_date": "2026-04-01",
        // "end_date": "2026-01-30",
        "compensatory_type": "request",
        "data_format": "details"
    }
    const getShortleaveDate = async (empcode) => {

        setBuffering(true);
        try {
            let res = await axios.post(
                `${BASE_URL}/wfm/get-compensatoryapplicabledates-byemp/${empcode}/`,
                eligibleDateConditions
            );

            if (res.status === 200) {
                setEligibleDates(res.data.eligible_dates || []);


            } else {
                toast.info(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false)
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        if (name === "empcode") {
            if (value !== '' && value !== null) {
                getShortleaveDate(value);
                getSelectedEmpData(value);
            }

            // Auto-select reporting head when employee is selected
            if (value && empList.length > 0) {
                // Find the reporting head from empData
                const reportingHeadEmail = empData?.reporting_head;

                if (reportingHeadEmail) {
                    // Find the reporting head in empList by email
                    const reportingHead = empList.find(emp =>
                        emp.is_reporthead && emp.email === reportingHeadEmail
                    );

                    if (reportingHead) {
                        // Determine designation for reporting head
                        let designation = "Reporting Head";

                        // Create the value string in the same format as the select options
                        const instructedByValue = `${reportingHead.emp_code} - ${reportingHead.name} (${designation})`;

                        setFormData((prev) => ({
                            ...prev,
                            instructed_by: instructedByValue
                        }));
                    }
                }
            }
        }


        else if (name === "sub_company") {
            // Reset employee-related fields when company changes
            setFormData((prev) => ({
                ...prev,
                sub_company: value,
                empcode: "",
                date: "",
                duration: "",
                instructed_by: "",
            }));
            setEligibleDates([]);
            setEmpData({});
            getAllEmp_code(value);
        }
    };


    // const handleDateSelect = (e) => {
    //     const { name, value, details } = e.target;
    //     setFormData((prev) => ({
    //         ...prev,
    //         [name]: value,
    //         duration: details?.short_leave?.eligible ? 'short leave' : 'comp off'
    //     }));
    // };

    const handleDateSelect = (selectedOption) => {
        if (!selectedOption) {
            setFormData((prev) => ({ ...prev, date: "", duration: "" }));
            return;
        }

        const selectedDateInfo = eligibleDates.find(d => d.date === selectedOption.value);

        // Short leave is ONLY eligible if not Civilmantra
        const shortEligible = selectedDateInfo?.short_leave?.eligible && canApplyShortLeave;
        const compEligible = selectedDateInfo?.comp_off?.eligible;

        let duration = "";
        if (compEligible) {
            duration = "comp off"; // Comp off works normally with priority
        } else if (shortEligible) {
            duration = "short leave";
        }

        setFormData((prev) => ({
            ...prev,
            date: selectedOption.value,
            duration: duration
        }));
    };

    // const handleDateSelect = (selectedOption) => {
    //     if (!selectedOption) {
    //         setFormData((prev) => ({
    //             ...prev,
    //             date: "",
    //             duration: ""
    //         }));
    //         return;
    //     }

    //     const selectedDateInfo = eligibleDates.find(d => d.date === selectedOption.value);
    //     const bothEligible = selectedDateInfo?.short_leave?.eligible && selectedDateInfo?.comp_off?.eligible;
    //     let duration = "";
    //     if (bothEligible) {
    //         duration = "comp off"; // Comp off gets priority
    //     } else if (selectedDateInfo?.short_leave?.eligible) {
    //         duration = "short leave";
    //     } else if (selectedDateInfo?.comp_off?.eligible) {
    //         duration = "comp off";
    //     }

    //     setFormData((prev) => ({
    //         ...prev,
    //         date: selectedOption.value,
    //         // duration: selectedDateInfo?.short_leave?.eligible ? 'short leave' : 'comp off'
    //         duration: duration
    //     }));
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/compensatoryrequest/`,
                    formData);

                if (res.status === 200 || res.status === 201) {
                    await getCompensatoryList();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Compensatory Log created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    useEffect(() => {
        if (EmpCode) {
            setFormData((prev) => ({
                ...prev,
                empcode: EmpCode
            }));

            getShortleaveDate(EmpCode);
            getSelectedEmpData(EmpCode);
        }
    }, [EmpCode]);

    useEffect(() => {
        if (formData.empcode && empData?.reporting_head && empList.length > 0) {
            const reportingHeadEmail = empData.reporting_head;
            const reportingHead = empList.find(emp =>
                emp.is_reporthead && emp.email === reportingHeadEmail
            );

            if (reportingHead) {
                let designation = "Reporting Head";
                const instructedByValue = `${reportingHead.emp_code} - ${reportingHead.name} (${designation})`;

                setFormData((prev) => ({
                    ...prev,
                    instructed_by: instructedByValue
                }));
            }
        }
    }, [empData, empList, formData.empcode]);

    return (
        <>
            <button title="Add Compensatory logs" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="">Compensatory</span>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="custom-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Compensatory Logs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form className="form-flex-wrap">
                                {SUPER_ADMIN && (
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <select
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company
                                                ? "error"
                                                : inputState.sub_company
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                            style={{ marginBottom: '0px' }}
                                        >
                                            <option value="">Select a Company</option>
                                            {SUB_COMPANIES.map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i.title}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.sub_company && (
                                            <span className="error-message font-size-text ">
                                                {errors.sub_company}
                                            </span>
                                        )}
                                    </div>
                                )}

                                {/* <div className="flex-column ">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        To Employee<span className="required">*</span>
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            name="empcode"
                                            value={formData.empcode}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.empcode
                                                ? "error"
                                                : inputState.empcode
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select An Employee</option>
                                            {empList
                                                .sort((a, b) => a.emp_code.localeCompare(b.emp_code))
                                                .map((i, index) => (
                                                    <option key={i.emp_code} value={i.emp_code}>
                                                        {i.name} - {i.emp_code}
                                                    </option>
                                                ))}
                                        </select>
                                    )}
                                    {errors.empcode && (
                                        <span className="error-message font-size-text ">
                                            {errors.empcode}
                                        </span>
                                    )}
                                </div> */}
                                <div className="flex-column ">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        To Employee<span className="required">*</span>
                                    </label>

                                    {PERMISSION_HR_ADMIN &&
                                        buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <Select
                                            options={customSortByKey(empList, "emp_code").map(emp => ({
                                                value: emp.emp_code,
                                                label: `${emp.emp_code} - ${emp.name}`
                                            }))}
                                            value={formData.empcode ? {
                                                value: formData.empcode,
                                                label: `${formData.empcode} - ${empList.find(emp => emp.emp_code === formData.empcode)?.name || ''}`
                                            } : null}
                                            onChange={(option) => {
                                                // Create a synthetic event to reuse handleInputChange
                                                const event = {
                                                    target: {
                                                        name: 'empcode',
                                                        value: option ? option.value : ''
                                                    }
                                                };
                                                handleInputChange(event);
                                            }}
                                            placeholder="Select An Employee"
                                            isClearable
                                            isSearchable
                                            styles={CustomCSSForSearchableSelect}
                                        />
                                    )}

                                    {errors.empcode && (
                                        <span className="error-message font-size-text ">{errors.empcode}</span>
                                    )}
                                </div>
                                <div title={`Date options start form : ${formattedDateLong(eligibleDateConditions.start_date)}`} className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Select Date<span className="required">*</span>
                                    </label>
                                    {buffer ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) :
                                        <>
                                            <Select
                                                options={eligibleDates
                                                    .filter(item => {
                                                        const shortEligible = item.short_leave?.eligible && canApplyShortLeave;
                                                        const shortExists = item.short_leave?.exists;
                                                        const compEligible = item.comp_off?.eligible;
                                                        const compExists = item.comp_off?.exists;

                                                        const shortLeaveAutoApply = PORTAL_SETTINGS?.shortleave_auto_apply;
                                                        const compOffAutoApply = PORTAL_SETTINGS?.compoff_auto_apply;

                                                        if (EmpCode) {
                                                            // For non-HR admins (EmpCode is provided)
                                                            // Show dates where:
                                                            // 1. Short leave is eligible AND doesn't exist AND auto-apply is disabled
                                                            // 2. OR Comp off is eligible AND doesn't exist AND auto-apply is disabled
                                                            return (
                                                                (shortEligible && !shortExists && !shortLeaveAutoApply) ||
                                                                (compEligible && !compExists && !compOffAutoApply)
                                                            );
                                                        } else {
                                                            // For HR admins (can select any employee)
                                                            // Show dates where:
                                                            // 1. Short leave is eligible AND auto-apply is disabled
                                                            // 2. OR Comp off is eligible AND auto-apply is disabled
                                                            // Don't filter by exists here since HR can see all
                                                            return (
                                                                (shortEligible && !shortLeaveAutoApply) ||
                                                                (compEligible && !compOffAutoApply)
                                                            );
                                                        }
                                                    })
                                                    .map(item => ({
                                                        value: item.date,
                                                        label: formattedDateLong(item.date),
                                                        isDisabled: (item.short_leave?.exists || item.comp_off?.exists),
                                                        item: item // Store original item for custom rendering
                                                    }))}
                                                value={formData.date ? {
                                                    value: formData.date,
                                                    label: formattedDateLong(formData.date),
                                                    item: eligibleDates.find(d => d.date === formData.date)
                                                } : null}
                                                onChange={handleDateSelect}
                                                // onChange={(selectedOption) => {
                                                //     const event = {
                                                //         target: {
                                                //             name: "date",
                                                //             value: selectedOption ? selectedOption.value : '',
                                                //             details: selectedOption ? eligibleDates.find(d => d.date === selectedOption.value) : '',
                                                //         }
                                                //     };

                                                //     handleDateSelect(event);
                                                // }}
                                                isClearable
                                                placeholder="-- Select a Date --"

                                                formatOptionLabel={(option, { context }) => {
                                                    const item = option.item;

                                                    const shortLeaveEligible = item?.short_leave?.eligible;
                                                    const shortLeaveExists = item?.short_leave?.exists;
                                                    const compOffEligible = item?.comp_off?.eligible;
                                                    const compOffExists = item?.comp_off?.exists;

                                                    return (
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            width: '100%'
                                                        }}>
                                                            <span>{option?.label}</span>

                                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                                {shortLeaveEligible && (
                                                                    <span style={{
                                                                        backgroundColor: '#64da64',
                                                                        color: 'white',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '12px',
                                                                        fontSize: '11px',
                                                                        fontWeight: '500',
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                        Short Leave Eligble
                                                                    </span>
                                                                )}
                                                                {compOffEligible && (
                                                                    <span style={{
                                                                        backgroundColor: '#64da64',
                                                                        color: 'white',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '12px',
                                                                        fontSize: '11px',
                                                                        fontWeight: '500',
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                        Comp Off Eligble
                                                                    </span>
                                                                )}
                                                                {(shortLeaveExists || compOffExists) && (
                                                                    <span style={{
                                                                        backgroundColor: '#ff4444',
                                                                        color: 'white',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '12px',
                                                                        fontSize: '11px',
                                                                        fontWeight: '500',
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                        Compensatory Req. Exists
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                }}
                                                styles={CustomCSSForSearchableSelect}
                                            />
                                            {errors.date && (
                                                <>
                                                    <div className="single-day-date"></div>
                                                    <span className="error-message font-size-text ">{errors.date}</span>
                                                </>
                                            )}
                                        </>

                                    }
                                </div>

                                <div className="flex-column ">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Instructed By<span className="required">*</span>
                                    </label>
                                    {buffer1 && buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <Select
                                            options={customSortByKey(empList, "emp_code")
                                                .filter(emp => emp.is_reporthead)
                                                .map(emp => {
                                                    // Determine the designation
                                                    let designation = emp.role;

                                                    // Check if this employee's email matches the reporting head email from empData
                                                    if (empData?.reporting_head && emp.email === empData.reporting_head) {
                                                        designation = "Reporting Head";
                                                    }
                                                    // Check if this employee has is_reportinghead true and role is reporting head
                                                    else if (emp.is_reporthead && emp.role === 'ReportingHead') {
                                                        designation = "Team Lead";
                                                    }

                                                    return {
                                                        value: `${emp.emp_code} - ${emp.name} (${designation})`,
                                                        label: `${emp.emp_code} - ${emp.name} (${designation})`,
                                                        emp_code: emp.emp_code,
                                                        name: emp.name,
                                                        designation: designation,
                                                        email: emp.email
                                                    };
                                                })}
                                            value={formData.instructed_by ? {
                                                value: formData.instructed_by,
                                                label: formData.instructed_by
                                            } : null}
                                            onChange={(option) => {
                                                const event = {
                                                    target: {
                                                        name: 'instructed_by',
                                                        value: option ? option.value : ''
                                                    }
                                                };
                                                handleInputChange(event);
                                            }}
                                            placeholder="Select Instructed By"
                                            isClearable
                                            isSearchable
                                            formatOptionLabel={(option, { context }) => {
                                                const isReportingHead = option.designation === "Reporting Head";
                                                return (
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        width: '100%'
                                                    }}>
                                                        <span>{option.label}</span>
                                                        {isReportingHead && context === 'menu' && (
                                                            <span style={{
                                                                backgroundColor: '#4CAF50',
                                                                color: 'white',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '10px',
                                                                marginLeft: '8px'
                                                            }}>
                                                                Reporting Head
                                                            </span>
                                                        )}
                                                    </div>
                                                );
                                            }}
                                            styles={CustomCSSForSearchableSelect}
                                        />
                                    )}
                                    {errors.instructed_by && (
                                        <span className="error-message font-size-text ">
                                            {errors.instructed_by}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels  font-weight500    font-size-subheading">Reason<span className="required">*</span></label>
                                    <textarea
                                        name="reason"
                                        className="form-input-textarea   font-weight400  form-input-background"
                                        placeholder="Reason"
                                        type="text"
                                        value={formData.reason}
                                        onChange={handleInputChange}
                                    />


                                    {errors.reason && (
                                        <span className="error-message font-size-text ">{errors.reason}</span>
                                    )}
                                </div>
                            </form>

                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    disabled={loading}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteCompoffShortLeaveForm = ({ i, getCompensatoryList }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);

        try {
            const res = await axios.delete(
                `${BASE_URL}/wfm/compensatoryrequest/${i.id}/`
            );

            if (res.status === 200) {
                await getCompensatoryList();
                setShow(false);
                toast.success("Compensatory Logs Deleted Successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };


    return (
        <>
            <button
                className="model-delete-button"
                onClick={handleShow}
                title="Delete Compensatory Logs"
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Compensatory Logs
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-details-box">
                        <div className="parent-div">
                            Are you sure you want to delete the short leave record on <b> {`${formatDate(i?.date)} (${i?.in_time} - ${i?.out_time}) `} </b> for <b> {`${i?.name}`} </b>?
                            <div className="button-models">
                                <button
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleDelete}
                                    className="model-button font-weight500 model-button-delete"
                                    disabled={loading}
                                >
                                    {loading ? "Deleting..." : "Delete"}
                                </button>
                            </div>
                        </div>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export { DeleteCompoffShortLeaveForm, AddCompoffShortLeaveForm }